import React from 'react';
import ValidatedDecimalInput from '../../../components/ValidatedDecimalInput/ValidatedDecimalInput';
import EditableTextField from './EditableTextField';
import EditableSelectField from './EditableSelectField';
import EditableMultiSelectField from './EditableMultiSelectField';

export default function OtherEquipmentTab({ project, editable, handleInputChange, handleSelectChange, handleFieldValidityChange }) {
  return (
    <table className='project-detail-table'>
      <tbody>
        <tr>
          <td>Hot Water System Manufacturer</td>
          <td>
            <EditableTextField
              name='hot_water_system_manufacturer'
              value={project.hot_water_system_manufacturer}
              onChange={handleInputChange}
              editable={editable === true}
            />
          </td>
        </tr>
        <tr>
          <td>Hot Water System Product Name</td>
          <td>
            <EditableTextField
              name='hot_water_system_product_name'
              value={project.hot_water_system_product_name}
              onChange={handleInputChange}
              editable={editable === true}
            />
          </td>
        </tr>
        <tr>
          {/* picklist */}
          <td>Hot Water System Type</td>
          <td>
            {/* Electric Water Heater, Solar Hot Water, Heat Pump Water Heater, Natural Gas Water Heater, Tankless Electric Water Heater, Tankless Gas Water Heater */}
            <EditableSelectField
              name='hot_water_system_type'
              value={project.hot_water_system_type}
              onChange={handleInputChange}
              editable={editable === true}
              disabledFallback='text'
              options={[
                'Electric Water Heater',
                'Solar Hot Water',
                'Heat Pump Water Heater',
                'Natural Gas Water Heater',
                'Tankless Electric Water Heater',
                'Tankless Gas Water Heater',
              ]}
            />
          </td>
        </tr>
        <tr>
          {/* picklist */}
          <td>Hot Water System Rating</td>
          <td>
            <EditableSelectField
              name='hot_water_system_rating'
              value={project.hot_water_system_rating}
              onChange={handleInputChange}
              editable={editable === true}
              disabledFallback='text'
              options={['Uniform Energy Factor (UEF)', 'Energy Factor (EF)']}
            />
          </td>
        </tr>
        <tr>
          <td>Hot Water System Performance</td>
          <td>
            <ValidatedDecimalInput
              name='hot_water_system_performance_rating'
              value={project.hot_water_system_performance_rating}
              onChange={(e) => handleInputChange(e)}
              editable={editable === true}
              onValidityChange={handleFieldValidityChange}
            />
          </td>
        </tr>
        <tr>
          {/* picklist */}
          <td>Hot Water System Layout</td>
          <td>
            <EditableSelectField
              name='hot_water_system_layout'
              value={project.hot_water_system_layout}
              onChange={handleInputChange}
              editable={editable === true}
              disabledFallback='text'
              options={['Centralized', 'Semi-Centralized', 'De-Centralized']}
            />
          </td>
        </tr>
        <tr>
          {/* picklist */}
          <td>Renewable Energy Type(s)</td>
          <td>
            <EditableMultiSelectField
              name='renewable_energy_types'
              value={project.renewable_energy_types}
              onChange={(option) => handleSelectChange('renewable_energy_types', option)}
              editable={editable === true}
              options={[
                { value: 'On-Site PV', label: 'On-Site PV' },
                { label: 'Off-Site PV', value: 'Off-Site PV' },
                {
                  label: 'Community Solar',
                  value: 'Community Solar',
                },
                { label: 'Virtual PPA', value: 'Virtual PPA' },
                { label: 'RECs', value: 'RECs' },
              ]}
            />
          </td>
        </tr>
        <tr>
          <td>Renewable Energy Manufacturer</td>
          <td>
            <EditableTextField
              name='renewable_energy_manufacturer'
              value={project.renewable_energy_manufacturer}
              onChange={handleInputChange}
              editable={editable === true}
            />
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Renewable Energy System Size</td>
          <td>
            <ValidatedDecimalInput
              name='renewable_energy_system_size'
              value={project.renewable_energy_system_size}
              onChange={(e) => handleInputChange(e)}
              editable={editable === true}
              onValidityChange={handleFieldValidityChange}
            />
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Renewable Energy Annual Production</td>
          <td>
            <ValidatedDecimalInput
              name='renewable_energy_annual_production'
              value={project.renewable_energy_annual_production}
              onChange={(e) => handleInputChange(e)}
              editable={editable === true}
              unit='kWh/yr'
              onValidityChange={handleFieldValidityChange}
            />
          </td>
        </tr>
        <tr>
          {/* picklist */}
          <td>Range Hood Type</td>
          <td>
            <EditableSelectField
              name='range_hood_type'
              value={project.range_hood_type}
              onChange={handleInputChange}
              editable={editable === true}
              disabledFallback='text'
              options={['Recirculation', 'Exhaust']}
            />
          </td>
        </tr>
        <tr>
          {/* picklist */}
          <td>Dryer Type</td>
          <td>
            <EditableSelectField
              name='dryer_type'
              value={project.dryer_type}
              onChange={handleInputChange}
              editable={editable === true}
              disabledFallback='text'
              options={['Vented', 'Non-Vented']}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
}
